import { Facebook, Instagram } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "./Logo";
import { CONTACT, NAV_LINKS } from "@/data/content";
import { useLenis } from "@/hooks/useLenis";

export const Footer = () => {
  const scrollTo = useLenis();

  const socialToast = (name) =>
    toast.info(`${name} — compte fictif`, {
      description: "Café des Arcades est un établissement de démonstration.",
    });

  return (
    <footer data-testid="site-footer" className="border-t border-[#F5F0E6]/10 bg-[#12281D] text-[#F5F0E6]">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo dark />
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-[#F5F0E6]/55">
              Café de spécialité, pâtisseries artisanales et cuisine du marché,
              au cœur du centre historique de Rennes.
            </p>
            <div className="mt-6 flex gap-3">
              <button
                type="button"
                data-testid="footer-instagram-button"
                onClick={() => socialToast("Instagram")}
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#F5F0E6]/15 text-[#F5F0E6]/70 transition-colors duration-300 hover:border-[#C85A32] hover:bg-[#C85A32] hover:text-[#FAF7F2]"
              >
                <Instagram size={16} />
              </button>
              <button
                type="button"
                data-testid="footer-facebook-button"
                onClick={() => socialToast("Facebook")}
                aria-label="Facebook"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#F5F0E6]/15 text-[#F5F0E6]/70 transition-colors duration-300 hover:border-[#C85A32] hover:bg-[#C85A32] hover:text-[#FAF7F2]"
              >
                <Facebook size={16} />
              </button>
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4A359]">Navigation</p>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    type="button"
                    data-testid={`footer-${link.testid}`}
                    onClick={() => scrollTo(link.href)}
                    className="font-display text-lg text-[#F5F0E6]/75 transition-colors duration-300 hover:text-[#D4A359]"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4A359]">Pratique</p>
            <ul className="mt-6 space-y-3 text-sm font-light text-[#F5F0E6]/65">
              <li data-testid="footer-address">
                {CONTACT.address}, {CONTACT.city}
              </li>
              <li>Mar. — Ven. : 8 h 00 – 19 h 00</li>
              <li>Samedi : 9 h 00 – 19 h 00</li>
              <li>Dimanche : 9 h 00 – 13 h 00</li>
              <li className="text-[#F5F0E6]/40">Fermé le lundi</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-[#F5F0E6]/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#F5F0E6]/40">
            © 2026 Café des Arcades — Tous droits réservés
          </p>
          <p
            data-testid="footer-demo-notice"
            className="max-w-md font-mono text-[11px] leading-relaxed tracking-[0.06em] text-[#F5F0E6]/40"
          >
            Établissement fictif — site de démonstration conçu pour illustrer la
            création de sites web pour cafés et restaurants.
          </p>
        </div>
      </div>
    </footer>
  );
};
